import styled from 'styled-components'

import { MEDIA_QUERY } from '../../../../styles'
import { Card } from '../../../common/card'
import { Content as ContentSize } from '../../../common/content'

const borderRadius = '10px'

export const Container = styled(ContentSize)`
  padding: 20px 0;
  @media ${MEDIA_QUERY.MOBILE} {
    padding-top: 10px;
  }
`

export const Content = styled(Card)`
  display: grid;
  grid-template-columns: auto 34%;
  border-radius: ${borderRadius};
  padding: 0;
  @media ${MEDIA_QUERY.MOBILE} {
    grid-template-columns: 100%;
    margin: 0 8px;
  }
`

export const Result = styled.section`
  background: ${({ theme }) => theme.colors.common.dark.brightBlue};
  border-radius: ${borderRadius};
  color: ${({ theme }) => theme.colors.font.white};
  height: 100%;
`

export const Input = styled.section`
  border-radius: ${borderRadius};
  padding: 30px 40px;
  @media ${MEDIA_QUERY.MOBILE} {
    padding: 30px;
  }
`
